module.exports = __webpack_public_path__ + "static/media/skopei-360.08eae4d3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/skopei-360.svg
// module id = 577
// module chunks = 14